// extracted by mini-css-extract-plugin
module.exports = {"container":"Item_container__1XyLp","icon":"Item_icon__ftiyF","content":"Item_content__21wMV"};